import { normalizeBooleanLike } from '@/utils/vehicleHistoryBooleanFields'

export function isModelEField(field: string): boolean {
  return String(field || '').trim() === 'is_model_e'
}

/** Preserves numeric/string 0|1 shapes when the field already stores feed values that way. */
export function packModelEValue(value: unknown, originalValue: unknown): unknown {
  const normalized = normalizeBooleanLike(value)
  const bool = normalized ?? false

  if (typeof originalValue === 'number' && Number.isFinite(originalValue)) {
    return bool ? 1 : 0
  }

  if (typeof originalValue === 'string') {
    const trimmed = originalValue.trim()
    if (trimmed === '0' || trimmed === '1') {
      return bool ? '1' : '0'
    }
  }

  return bool
}
